module.exports = __webpack_public_path__ + "static/media/shutterstock_12763744_ppcc.f59fda79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/shutterstock_12763744_ppcc.jpg
// module id = 1787
// module chunks = 1